<template>
  <div class="qr-redirect-container">
    <div class="loading-content">
      <!-- 简单的 CSS 旋转动画 -->
      <div class="spinner"></div>
      <p class="loading-text">正在加载注册页面...</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QRRedirect',
  created() {
    // 获取 URL 参数
    const query = this.$route.query;
    const invitationCode = query.invitation_code;
    
    if (invitationCode) {
      // 将邀请码存储到 sessionStorage（安全，不会暴露在 URL 中）
      sessionStorage.setItem('invitation_code', invitationCode);
      
      // 延迟一下，确保存储完成后再跳转
      setTimeout(() => {
        // 跳转到注册页面（不带任何参数）
        this.$router.replace({ path: '/Register' });
      }, 300);
    } else {
      // 没有邀请码，直接跳转
      setTimeout(() => {
        this.$router.replace({ path: '/Register' });
      }, 100);
    }
  }
};
</script>

<style scoped>
.qr-redirect-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f5f7fa;
}

.loading-content {
  text-align: center;
}

/* 简单的 CSS 旋转加载动画 */
.spinner {
  width: 50px;
  height: 50px;
  margin: 0 auto 20px;
  border: 4px solid #e4e7ed;
  border-top-color: #409EFF;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.loading-text {
  font-size: 16px;
  color: #606266;
}
</style>
